import React, { useState, useEffect } from "react";

interface Option {
  label: string;
  value: string;
}

interface Props {
  index?: number;
  title: string;
  note?: string;
  options: Option[];
  onChange: (selected: string) => void;
  selected?: string;
  error?: string;
  disabled?: boolean;
}

const SingleSelect = ({ index, title, note, options, onChange, selected = "", error, disabled = false }: Props) => {
  const [selectedValue, setSelectedValue] = useState<string>(selected);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setSelectedValue(selected); // sync with external prop
  }, [selected]);

  const handleSelect = (value: string) => {
    setSelectedValue(value);
    onChange(value);
    setOpen(false);
  };

  return (
    <div className={`flex flex-col w-full space-y-2 ${disabled ? "text-skgray" : ""}`}>
      <div className="flex items-center pb-[5px]">
        <span>{index && <span className="content_count">{index}</span>}</span>
        {title && <span className="content_title">{title}</span>}
      </div>
      {note && <div className="notes-class-content !my-[0px]">{note}</div>}

      <div className="relative w-64 text-sm mt-[15px]">
        <div tabIndex={0} onClick={() => setOpen(!open)} className="flex items-center justify-between px-4 py-2 border cursor-pointer rounded-xl">
          <span>{selectedValue ? options.find(o => o.value === selectedValue)?.label : "Select an option"}</span>
          <svg
            className={`w-4 h-4 ml-2 transition-transform transform ${disabled ? "hidden" : ""}`}
            style={{ transform: open ? "rotate(180deg)" : "" }}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>

        {!disabled && open && (
          <div className="absolute z-10 w-full mt-1 overflow-y-auto bg-white border rounded shadow max-h-60">
            {options.map(opt => (
              <div
                key={opt.value}
                onClick={() => handleSelect(opt.value)}
                className={`px-4 py-2 cursor-pointer hover:bg-gray-100 ${selectedValue === opt.value ? "bg-gray-100 font-medium" : ""}`}
              >
                {opt.label}
              </div>
            ))}
          </div>
        )}
      </div>

      {error && <span className="block mb-2 text-sm text-red-600 dark:text-red-500">{error}</span>}
    </div>
  );
};

export default SingleSelect;
